import { useState, useEffect } from "react";
import HSTable from "../../components/global/Table";
import { getAllDeaeratorBudgets } from "../../services/budgets_excel/DeaeratorBudgetService";
import { IconButton } from "@mui/material";
import { Search } from "@mui/icons-material";
import DeaeratorBudgetDetail from "../../components/budgets_excel/DeaeratorBudgetDetail";

const DeaeratorBudgets = () => {

    const columns = [
        { field: "name", label: "Descrição", sortable: true },
        { field: "sourceFile", label: "Ficheiro", sortable: true },
        {
            field: "capacityTonPerHour",
            label: "Capacidade (ton/h)",
            sortable: true,
            align: "right",
            render: (value) => value != null ? `${value} ton/h` : "—",
        },
        {
            field: "operatingTemperatureCelsius",
            label: "Temp. (ºC)",
            sortable: true,
            align: "right",
            render: (value) => value != null ? `${value} ºC` : "—",
        },
        {
            field: "operatingPressureBar",
            label: "Pressão (bar)",
            sortable: true,
            align: "right",
            render: (value) => value != null ? `${value} bar` : "—",
        },
        {
            field: "totalSalePrice",
            label: "Preço de Venda",
            sortable: true,
            align: "right",
            render: (value) => value != null
                ? value.toLocaleString("pt-PT", { style: "currency", currency: "EUR" })
                : "—",
        },
        {
            field: "actions",
            label: "Ver Detalhes",
            align: "center",
            render: (_, row) => (
                <IconButton onClick={() => handleViewDetails(row)}>
                    <Search fontSize="medium" sx={{ color: "primary.main" }} />
                </IconButton>
            ),
        },
    ];

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [totalElements, setTotalElements] = useState(0);
    const [searchString, setSearchString] = useState("");
    const [selectedBudget, setSelectedBudget] = useState(null);

    useEffect(() => {
        (async () => {
            setLoading(true);
            await getAllDeaeratorBudgets(page, rowsPerPage, searchString).then((res) => {
                setTotalElements(res["totalElements"]);
                setData(res["content"]);
                setLoading(false);
            });
        })();
    }, [page, rowsPerPage, searchString]);

    const handleViewDetails = (budget) => {
        setSelectedBudget(budget);
    };

    return (
        <>
            <div style={{ boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)' }}>
                <HSTable
                    columns={columns}
                    data={data}
                    loading={loading}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    enableSearch={true}
                    totalCount={totalElements}
                    onRowsPerPageChange={(newRowsPerPage) => { setRowsPerPage(newRowsPerPage); setPage(0); }}
                    onPageChange={(page) => setPage(page)}
                    onSearchChange={(search) => setSearchString(search)}
                />
            </div>
           {selectedBudget && (
                <DeaeratorBudgetDetail
                    budget={selectedBudget}
                    onClose={() => setSelectedBudget(null)}
                />
            )}
        </>
    );
};

export default DeaeratorBudgets;